/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import {arrayToCombo} from '../Helpers'
import {client} from '../Client';

class TipoDocumentoComboFilter extends Component {
    constructor(props) {
        super(props);
        let fields = {codice: props.codice}
        this.state = {
            fields: fields,
            dropdownLoading: false,
            dropdownList: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.comboTipoDocumento = this.comboTipoDocumento.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if (nextProps.codice !== this.state.fields.codice)
        {
            let fields = this.state.fields;
            fields.codice = nextProps.codice;
            this.setState({fields},
                ()=>{
                    if ( this.state.fields.codice !== undefined){
                        this.props.onChange(
                            this.state.fields.codice,
                            this.getDDText(this.state.fields.codice, this.state.dropdownList)
                        );
                    }
                });
        }
    }

    componentDidMount(){
        this.comboTipoDocumento();
    }

    getDDText(value, options){
        let selectedItem = options.find((it) => {
            return it.value === value;
        })
        return selectedItem ? selectedItem.text : '-1';
    }

    comboTipoDocumento(){
        this.setState({ dropdownLoading: true });

        client.loadTipiDocumentoTuttiList().then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{

                    let items = [{codiceTipoDocumento: '-1', nome: 'Tutti i tipi di documento'}];
                    items = items.concat(data.items);
                    this.setState({
                            dropdownLoading: false,
                            error: null,
                            dropdownList: arrayToCombo(items, "codiceTipoDocumento", "nome", "codiceTipoDocumento", false)
                        },
                        ()=>{
                            if ( this.state.fields.codice !== undefined){
                                this.props.onChange(
                                    this.state.fields.codice,
                                    this.getDDText(this.state.fields.codice, this.state.dropdownList)
                                );
                            }
                        })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownLoading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownLoading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });


    }

    onInputChange(a1, b1) {

        let name = b1.name;
        let value = b1.value;

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields }, () => {
                this.props.onChange(this.state.fields.codice, this.getDDText(value, b1.options));
            });

        }
    }

    render() {
        return (
            <div className="ui form">
                <div className="inline fields">
                    <Form.Field className="inline fields" width={16}>
                        <Form.Dropdown width={16} style={{width:"100%"}} name='codice' disabled={this.props.abilitato === false} loading={this.state.dropdownLoading} search selection options={this.state.dropdownList} value={this.state.fields.codice} onChange={this.onInputChange}/>
                    </Form.Field>
                </div>
            </div>)
    }
}

TipoDocumentoComboFilter.PropTypes = {
    codice: PropTypes.string.isRequired,
    abilitato: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

TipoDocumentoComboFilter.defaultProps = {
    codice: '-1',
    abilitato: false
};
export default TipoDocumentoComboFilter;



/** WEBPACK FOOTER **
 ** ./src/components/TipoDocumentoComboFilter.js
 **/